import React from 'react';

const DocumentCriticalIcon = (props)  => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      style={{
        height: props.height ? `${props.height}px` : '',
        width: props.height ? `${props.height * 0.75}px` : ''
      }}
      viewBox="0 0 18 24"
    >
      <path fill="#FF0" d="M1 0v23h16.5V7l-7-7H1Z"/>
      <path fill="#606000" fillRule="evenodd" d="M17.498 7.073 10.988.5a1.802 1.802 0 0 0-.446-.323c-.016-.01-.034-.017-.05-.024l-.015-.007A1.677 1.677 0 0 0 9.797 0H1.71C.778 0 0 .755 0 1.688v20.625C0 23.244.778 24 1.71 24h14.602c.933 0 1.665-.755 1.665-1.688V8.262c0-.446-.165-.872-.479-1.189ZM10 1l7 7h-6a1 1 0 0 1-1-1V1Zm6 22a1 1 0 0 0 1-1V8.8h-6.138C9.84 8.8 8.987 7.995 8.987 7V1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h14Z" clipRule="evenodd"/>
      <path fill="#606000" fillRule="evenodd" d="M3.662 18.164a1 1 0 0 0 .84 1.543h9.327a1 1 0 0 0 .84-1.543l-4.664-7.207a1 1 0 0 0-1.68 0l-4.663 7.207Zm6.25.156a.747.747 0 1 1-1.495 0 .747.747 0 0 1 1.495 0Zm-.747-1.413a.747.747 0 0 0 .747-.747v-2.988a.747.747 0 1 0-1.495 0v2.988c0 .413.335.747.748.747Z" clipRule="evenodd"/>
    </svg>
  );
};

DocumentCriticalIcon.defaultProps = { height: 24 };
export default DocumentCriticalIcon;
